<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
    },
};
</script>

<template functional>
  <div class="card medium:flex p-4">

      <div class='medium:flex-1'>
        <h3 class='text-xl hidden medium:block' :class="{
            'mb-2': $slots.default
        }">{{ props.title }}</h3>
        <div v-if="$slots.default" class="text-center medium:text-left">
            <slot></slot>
        </div>
        <h3 class='text-xl text-center block medium:hidden' :class="{
            'border-50 border-t pt-4 mt-4': $slots.default,
            'border-50 border-b pb-4 mb-4': $slots.badges,
        }">{{ props.title }}</h3>
      </div>
      <div v-if="$slots.badges" class="text-center medium:text-right">
        <slot name="badges"></slot>
      </div>

  </div>
</template>
